// external imports 
import html2PDF from 'jspdf-html2canvas'
import { toBlob } from 'html-to-image'
import axios from 'axios'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
// custom imports
import {
    getItem,
    setItem,
    ALL_DASHBOARD_ITEMS,
    DASHBOARD_ITEMS,
    REPORT_ID
} from '../helpers/config'
import cache from '../helpers/cache'
import dashboardItems from '../dashboardItems/dashboardItems.json'
import dashboardFilter from './dashboardFilter'
import dashboardClient from "./dashboardClient"

const getExportOptions = (clientName, fState) => {
    let dateRangeFormatted = fState.dateRange.map(val => moment(val).format('DD MMM YYYY'))
    let options = []

    if (clientName == 'expo') {
        options = options.concat([
            // {
            //     value: "currentFilter",
            //     text: `For ${fState.expoCountry} between ${dateRangeFormatted[0]} and ${dateRangeFormatted[1]}`
            // },
            {
                value: "each",
                text: `For each country between ${dateRangeFormatted[0]} and ${dateRangeFormatted[1]}`
            }
        ])
    } else {
        options.push({
            value: "currentFilter",
            text: `Between ${dateRangeFormatted[0]} and ${dateRangeFormatted[1]}`
        })
    }

    return options
}

/**
 * return cached dashboard items
 */
const getDashboardItems = () => {
    let data = getItem(ALL_DASHBOARD_ITEMS)
    if (!data) {
        data = dashboardItems
        setDashboardItems(data)
    }
    return data
}

/**
 * cache the dashboard items
 */
const setDashboardItems = (dashItems) => {
    setItem(dashItems || dashboardItems, ALL_DASHBOARD_ITEMS)
}

const getLocalDashboardItems = () => {
    return JSON.parse(window.localStorage.getItem(DASHBOARD_ITEMS))
}

const setLocalDashboardItems = (dashItems) => {
    window.localStorage.setItem(
        DASHBOARD_ITEMS,
        JSON.stringify(dashItems) ||
        JSON.stringify(dashboardItems.dashboardItems)
    )
}

const getDashboardItemsForClient = (selectedClient) => {
    const data = getDashboardItems()
    const clientData = data.dashboardItems.filter(dashboardItem =>
        dashboardItem.clientNames?.some(clientName =>
            clientName == selectedClient
        )
    )
    return {
        dashboardItems: clientData
    }
}

const getChartOrientation = (id) => (
    getDashboardItemAttribute(id, 'chartOrientation')
)

const getTableName = (id) => (
    getDashboardItemAttribute(id, 'tableName')
)

const getHasLegend = (id) => (
    getDashboardItemAttribute(id, 'hasLegend')
)

const getHeight = (id) => (
    getDashboardItemAttribute(id, 'height')
)

const getWidth = (id) => (
    getDashboardItemAttribute(id, 'width')
)

const getIsSentiment = (id) => getDashboardItemAttribute(id, 'isSentiment')

/**
 * return a given attribute of a dashboard item
 */
const getDashboardItemAttribute = (id, attributeName) => {
    let data = getDashboardItems() || dashboardItems

    let dashItem = data.dashboardItems.find(item => item.id == id)
    return (!!dashItem ? dashItem[attributeName] : undefined)
}

const exportToPdf = async (divName) => {
    let page = document.getElementById(divName)
    let isSuccess = undefined
    try {
        await html2PDF(page, {
            jsPDF: {
                format: 'a4',
                orientation: 'landscape'
            },
            imageType: 'image/jpeg',
            output: './pdf/generate.pdf',
            html2canvas: {
                scrollX: 0,
                scrollY: -window.scrollY,
            },
        })
        // console.log("Here is the pdf: ", pdf)
        isSuccess = true
    } catch (err) {
        isSuccess = false
    } finally {
        return isSuccess
    }
}

// const testSave = (divName) => {
//     toPng(document.getElementById(divName)/* , { canvasHeight: getHeight(divName), canvasWidth: getWidth(divName) } */)
//         .then((dataUrl) => {
//             download(dataUrl, `${divName}-test.png`)
//         })
// }

const uploadToGCP = async (reportId, clientName, expoCountry) => {
    let dashboardItems = getDashboardItemsForClient(clientName).dashboardItems // getDashboardItems().dashboardItems
    let final
    try {
        let promises = dashboardItems.map(async (dashboardItem) => {
            const { id } = dashboardItem
            return await uploadChart(id, reportId, clientName, expoCountry)
        })

        let results = await Promise.all(promises)
        final = results.reduce((acc, success) => {
            return acc && success
        }, true)
    } catch (err) {
        final = false
    } finally {
        return final
    }

}

const downloadReport = async (reportId, clientName, exportProgress, setExportProgress) => {
    let body = {
        bucket_name: process.env.REACT_APP_BUCKET_NAME,
        reportId,
        clientName
    }
    let success

    try {
        axios.post(
            `${process.env.REACT_APP_REPORT_API}/gen-report`,
            body
        ).then((res) => {
            setExportProgress({
                ...exportProgress,
                progress: 100,
                status: 'success',
                message: 'Your report will be downloaded shortly'
            })
            console.log(res.data.download_url)
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = res.data.download_url;
            a.click();

            success = true

        }).catch((err) => {
            console.log("axios error: ", err)
            throw err
        })
    } catch (err) {
        console.log(err)
        setExportProgress({ ...exportProgress, status: 'exception', message: 'Error downloading report' })
        success = false
    } finally {
        return success
    }

}

const uploadChart = (id, reportId, clientName, expoCountry) => {

    let success = new Promise((resolve, reject) => {
        let div = document.getElementById(`render-${id}`)
        let formData = new FormData()
        formData.append('bucket_name', `${process.env.REACT_APP_BUCKET_NAME}`)

        let filePath = expoCountry ? `${clientName}/${reportId}/${expoCountry}/chart-${id}` : `${clientName}/${reportId}/chart-${id}`
        formData.append('file_path', filePath)
        // console.log("file path:", filePath)

        let options = {
            // canvasHeight: getHeight(id),
            // canvasWidth: getWidth(id),
            backgroundColor: "#00000000"
        }
        // testSave(`render-${id}`)

        toBlob(div, options)
            .then((blob) => {
                formData.append('file', blob)
                axios
                    .post(
                        `${process.env.REACT_APP_FILE_API_GCP}/upload`,
                        formData
                    )
                    .then(() => {
                        resolve(true)
                    })
                    .catch(() => {
                        reject(false)
                    })
            })
    })

    success
        .then((resolved) => {
            // console.log("success", resolved)
        })
        .catch((rejected) => {
            // console.log("failed", rejected)
        })

    return success
}

const uploadConfig = async (reportId, clientName, isDefaultLayout) => {

    let success

    try {
        const fState = dashboardFilter.getFilterState()
        let dateRange = fState?.dateRange.map(val => moment(val).format('DD MMM YYYY'))
        const layoutMode = isDefaultLayout ? "default" : "new"

        const exportFile = {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            reportId,
            reportName: `${dashboardClient.getClientObject(clientName)?.label} Report.pptx`,
            dateRange,
            clientName,
            layoutMode
        }

        const json = JSON.stringify(exportFile)
        const blob = new Blob([json], { type: 'application/json' })

        let filePath = `${clientName}/${reportId}/config`
        let formData = new FormData()
        formData.append('bucket_name', `${process.env.REACT_APP_BUCKET_NAME}`)
        formData.append('file_path', filePath)
        formData.append('file', blob)

        await axios.post(
            `${process.env.REACT_APP_FILE_API_GCP}/upload`,
            formData
        )

        success = true

    } catch (err) {
        success = false
        console.log("error uploading config file: ", err)
    } finally {
        return success
    }

}

const getReportId = () => {
    let reportId = cache.getItem(REPORT_ID)
    if (!reportId) {
        reportId = `report-${uuidv4()}`
        setReportId(reportId)
    }
    return reportId
}

const setReportId = (rId) => cache.setItem(REPORT_ID, rId || `report-${uuidv4()}`)

const removeReportId = () => cache.removeItem(REPORT_ID)


export default {
    getDashboardItems,
    setDashboardItems,
    getLocalDashboardItems,
    setLocalDashboardItems,
    getChartOrientation,
    getTableName,
    getHasLegend,
    getHeight,
    getWidth,
    exportToPdf,
    downloadReport,
    uploadToGCP,
    uploadConfig,
    getExportOptions,
    getIsSentiment,
    getDashboardItemAttribute,
    getDashboardItemsForClient,
    getReportId,
    setReportId,
    removeReportId
}